<template>
<div class="d-lg-none">
  <button type="button" class="btn btn-bars" :class="btnBarsClass" @click="isOpen = !isOpen">
    <span class="top"></span>
    <span class="middle"></span>
    <span class="bottom"></span>
  </button>
  <div class="logo-mobile">
    <svg id="logo-mobile" :class="{white: $route.name == 'Home' && !(currentPage >= (isMobile().phone? 3 : 2) && currentPage <= 6)}" xmlns="http://www.w3.org/2000/svg" width="222" height="25" viewBox="0 0 221.88 24.61">
      <path  d="M168.56,23.58a2.28,2.28,0,0,1-.94-.88,15.22,15.22,0,0,1-1.18-2.58L159,0h-.58L151,20.54a6.69,6.69,0,0,1-1.38,2.39,2.83,2.83,0,0,1-1.88.9v.25h5.72v-.25a2.52,2.52,0,0,1-1.4-.33,1.49,1.49,0,0,1-.49-1.31,6.59,6.59,0,0,1,.38-1.88l2-5.74h8L164.21,21a5.06,5.06,0,0,1,.32,1.44c0,.65-.22,1.06-.64,1.2a5.6,5.6,0,0,1-1.81.23v.25h7.63v-.25A4.4,4.4,0,0,1,168.56,23.58ZM154.3,13.73l3.6-10.29h0l3.69,10.29Z"/>
      <path  d="M195.86,5.59h-.25a5.3,5.3,0,0,0-2.68-3.53,9.84,9.84,0,0,0-5-1.25,11.92,11.92,0,0,0-3.11.45,9.51,9.51,0,0,0-3.24,1.63A8.67,8.67,0,0,0,179,6.32,13.37,13.37,0,0,0,178,12a13.73,13.73,0,0,0,2.53,8.67c1.69,2.16,4.4,3.25,8.13,3.25a12.82,12.82,0,0,0,3.25-.3,2.18,2.18,0,0,0,1.33-.82,3,3,0,0,0,.29-1.41V17.12a2.45,2.45,0,0,0-.65-2,4.14,4.14,0,0,0-2-.64V14.2h7.56v.27a3.87,3.87,0,0,0-1.61.45,1.64,1.64,0,0,0-.76.87,4.27,4.27,0,0,0-.19,1.42v6.47a27.52,27.52,0,0,1-7.16.93,22.57,22.57,0,0,1-3.77-.32,12.87,12.87,0,0,1-3.88-1.4,10.79,10.79,0,0,1-3.56-3.22,12,12,0,0,1-2.32-7.24,12.59,12.59,0,0,1,3.4-8.55,11.85,11.85,0,0,1,4-2.78,13.29,13.29,0,0,1,5.28-1,15.69,15.69,0,0,1,2.19.15c.72.1,1.79.31,3.21.61a5.85,5.85,0,0,0,1.19.19,1.2,1.2,0,0,0,1.14-.77h.25Z"/>
      <path  d="M0,23.82H.32a2.06,2.06,0,0,0,1.53-.68,2.62,2.62,0,0,0,.66-1.91V3.46a2.47,2.47,0,0,0-.74-2A3.07,3.07,0,0,0,0,.8V.53H7.53V.8a3.17,3.17,0,0,0-1.76.59A2.43,2.43,0,0,0,5,3.46V20.64a2.55,2.55,0,0,0,.77,2.13,4.19,4.19,0,0,0,2.51.59h2A5.84,5.84,0,0,0,12.43,23a2.71,2.71,0,0,0,1.25-1,9.29,9.29,0,0,0,1-1.86h.27L14,24.08H0Z"/>
      <path  d="M23,.8V.53h14V4.24h-.22q0-3-4-3H28V12h4.31a6.07,6.07,0,0,0,2.29-.41,2.08,2.08,0,0,0,1.15-1.91H36V15h-.24a3.06,3.06,0,0,0-.54-1.4,2.1,2.1,0,0,0-.79-.64,1.88,1.88,0,0,0-.7-.16,6.62,6.62,0,0,0-1.2-.1H28V21a3.47,3.47,0,0,0,.36,1.63c.24.46.79.69,1.67.69h3.5A5,5,0,0,0,35.57,23a3,3,0,0,0,1.28-1,6,6,0,0,0,.79-1.58h.23l-.82,3.69H23v-.26h.32a2.29,2.29,0,0,0,1.47-.6,2.48,2.48,0,0,0,.72-2V3.49A3.62,3.62,0,0,0,25,1.6a1.84,1.84,0,0,0-1.7-.8Z"/>
      <path  d="M75.85,5.06H75.6a5.13,5.13,0,0,0-1.5-3A4.47,4.47,0,0,0,70.76.77a4.63,4.63,0,0,0-2.42.64,4.4,4.4,0,0,0-1.63,1.74,5.45,5.45,0,0,0-.57,2.53,5.23,5.23,0,0,0,.34,2,4.5,4.5,0,0,0,1,1.51,9.25,9.25,0,0,0,1.59,1.22c.6.38,1.42.86,2.46,1.43a18.52,18.52,0,0,1,4,2.84A5.19,5.19,0,0,1,77,18.52a5.87,5.87,0,0,1-.78,2.9,6.07,6.07,0,0,1-2.34,2.29,7.72,7.72,0,0,1-3.89.9,9.94,9.94,0,0,1-2.57-.31,13.08,13.08,0,0,1-2.27-.88,2.9,2.9,0,0,0-.66-.16.41.41,0,0,0-.43.24,6.29,6.29,0,0,0-.28,1h-.28v-5.9h.28A6.65,6.65,0,0,0,66,22.56a6.27,6.27,0,0,0,4,1.33,5.47,5.47,0,0,0,2.87-.67,3.66,3.66,0,0,0,1.49-1.63,4.76,4.76,0,0,0,.42-1.92,4.47,4.47,0,0,0-1.21-3.24A14.78,14.78,0,0,0,70,13.86c-1.13-.61-2-1.09-2.51-1.43a11.06,11.06,0,0,1-1.65-1.33,6.25,6.25,0,0,1-1.34-1.93A6.2,6.2,0,0,1,64,6.62a6.21,6.21,0,0,1,.88-3.18A6.56,6.56,0,0,1,67.35,1,7.31,7.31,0,0,1,71,.08a10.34,10.34,0,0,1,3.18.53,1.49,1.49,0,0,0,.69.13q.53,0,.72-.72h.25Z"/>
      <path  d="M104,23.82h.32a2,2,0,0,0,1.52-.68,2.59,2.59,0,0,0,.67-1.91V3.46a2.44,2.44,0,0,0-.75-2A3,3,0,0,0,104,.8V.53h7.53V.8a3.17,3.17,0,0,0-1.76.59A2.43,2.43,0,0,0,109,3.46V20.64a2.55,2.55,0,0,0,.77,2.13,4.19,4.19,0,0,0,2.51.59h2a5.87,5.87,0,0,0,2.12-.32,2.81,2.81,0,0,0,1.25-1,8.83,8.83,0,0,0,.94-1.86h.28l-.9,3.87H104Z"/>
      <path  d="M126.3,23.82h.32a2.06,2.06,0,0,0,1.53-.68,2.62,2.62,0,0,0,.66-1.91V3.46a2.47,2.47,0,0,0-.74-2A3.07,3.07,0,0,0,126.3.8V.53h7.53V.8a3.17,3.17,0,0,0-1.76.59,2.43,2.43,0,0,0-.77,2.07V20.64a2.55,2.55,0,0,0,.77,2.13,4.19,4.19,0,0,0,2.51.59h2a5.84,5.84,0,0,0,2.12-.32,2.71,2.71,0,0,0,1.25-1,9.29,9.29,0,0,0,1-1.86h.27l-.9,3.87h-14Z"/>
      <path  d="M207,.8V.53h14V4.24h-.23q0-3-4-3H212V12h4.32a6.06,6.06,0,0,0,2.28-.41,2.06,2.06,0,0,0,1.15-1.91H220V15h-.24a2.86,2.86,0,0,0-.54-1.4,2.1,2.1,0,0,0-.79-.64,1.8,1.8,0,0,0-.7-.16,6.62,6.62,0,0,0-1.2-.1H212V21a3.47,3.47,0,0,0,.36,1.63c.24.46.8.69,1.67.69h3.5a5,5,0,0,0,2.08-.37,3.13,3.13,0,0,0,1.29-1,6.66,6.66,0,0,0,.79-1.58h.22l-.81,3.69H207v-.26h.32a2.29,2.29,0,0,0,1.47-.6,2.48,2.48,0,0,0,.72-2V3.49a3.53,3.53,0,0,0-.49-1.89,1.83,1.83,0,0,0-1.7-.8Z"/>
      <path  d="M89.14,2.89V21.32c0,2.49,2,3.29,5,3.29v-.24a2.74,2.74,0,0,1-1.74-.61,2.37,2.37,0,0,1-.78-2V3.37C91.57.85,89.69.08,86.63.08V.33a2.84,2.84,0,0,1,1.76.55A2.33,2.33,0,0,1,89.14,2.89Z"/>
    </svg>
  </div>
  <div class="xs-menu d-flex flex-column" :class="{isOpen: isOpen}">
    <div class="p-3">
      <!-- <img style="height: 60px;" src="@/assets/logo-white.svg"> -->
    </div>
    <div class="flex-fill">
      <div class="d-flex flex-column h-100 w-100 justify-content-around align-items-center">
        <b-button variant="light" @click="clickMenu(0)">top</b-button>
        <b-button variant="light" @click="clickMenu(1)">concept</b-button>
        <b-button variant="light" @click="clickMenu(2)">news</b-button>
        <b-button variant="light" @click="clickMenu(3)">brand</b-button>
        <b-button variant="light" @click="clickMenu(4)">type &amp; notes</b-button>
        <b-button variant="light" @click="clickMenu(5)">library</b-button>
        <b-button variant="light" @click="clickMenu(6)">information</b-button>
        <b-button variant="light" @click="clickMenu(7)">reservation</b-button>
        <b-button variant="light" @click="clickMenu(8)">Online Store</b-button>
        <b-button variant="light" class="" href="https://www.instagram.com/lesillage_kyoto/" target="_blank">
          <font-awesome-icon :icon="['fab', 'instagram']" />
        </b-button>
      </div>
    </div>
  </div>
</div>  
</template>

<script>
import { mapState, mapActions } from 'vuex'
import isMobile from 'ismobilejs'

export default {
  data() {
    return {
      isMobile,
      isOpen: false
    }
  },
  mounted() {
    console.log('router.name', this.$route.name)
  },
  computed: {
    ...mapState({
      currentPage: state => state.currentPage
    }),
    btnBarsClass() {

      if (this.$route.name === 'Home') {
        if (this.currentPage >= (this.isMobile().phone? 3 : 2) && this.currentPage <= 6) {
          if (this.isOpen) {
            return 'isOpen'
          }
          return ''
        }
        else {
          if (this.isOpen) {
            return 'isOpen wghite'
          } else {
            return 'white'
          }
        } 
      } else {
        if (this.isOpen) {
          return 'isOpen'
        } else {
          return ''
        }
      } 
    }
  },
  methods: {
    ...mapActions({
      storePage: 'doSetPage'
    }),
    clickMenu(pageNo) {
      if (this.$route.name != 'Home') {
        if (pageNo == 0) {
          this.$router.push({name: 'Home', hash: '#top'})
        } else if (pageNo == 1) {
          this.$router.push({name: 'Home', hash: '#concept'})
        } else if (pageNo == 2) {
          this.$router.push({name: 'Home', hash: '#news'})
        } else if (pageNo == 3) {
          this.$router.push({name: 'Home', hash: '#brand'})
        } else if (pageNo == 4) {
          this.$router.push({name: 'Home', hash: '#type'})
        } else if (pageNo == 5) {
          this.$router.push({name: 'Home', hash: '#library'})
        } else if (pageNo == 6) {
          this.$router.push({name: 'Home', hash: '#information'})
        } else if (pageNo == 7) {
          this.$router.push({name: 'Home', hash: '#reservation'})
        } else if (pageNo == 8) {
          this.$router.push({name: 'Home', hash: '#onlinestore'})
        }
      } else {
        this.storePage(pageNo)
      }
      this.isOpen = false
    },
  }
}
</script>

<style lang="scss" scoped>
$sidebar-width: 60px;
.btn-bars {
  position: fixed;
  top: 0;
  left: 0;
  width: $sidebar-width;
  height: $sidebar-width;
  display: block;
  background-color: transparent;
  z-index: 21;
  &:focus {
    box-shadow: none;
  }
}
$btn-bar-width: 30px;
.btn-bars {
  span {
    width: $btn-bar-width;
    height: 2px;
    display: block;
    background: #333;
    position: absolute;
    left: 50%;
    top: calc(50% - 1px);
    margin-left: -15px;
  }
  .top {
    transform: translateY(-11px) scale(1);
  }
  .middle {
    background: none;
    position: relative;
    &:after, &:before {
      transition: all 0.3s;
      content: "";
      width: $btn-bar-width;
      height: 2px;
      background-color: #333;
      display: block;
      transform: rotate(0deg);
      position: absolute;
    }
  }
  .bottom {
    transform: translateY(11px) scale(1);
    width: 20px;
  }
  span {
    transition: all 0.3s;
  }
  &.isOpen {
    .top {
      transform: translateY(0px) scale(0);
    }
    .middle:before {
      transform: rotate(45deg);
      background-color: #333 !important;
    }
    .middle:after {
      transform: rotate(-45deg);
      background-color: #333 !important;
    }
    .bottom {
      transform: translateY(0px) scale(0);
    }
  }
  &.white {
    span {
      background-color: #fff;
    }
    .middle {
      &:after, &:before {
        background-color: #fff;
      }
    }
  }
}
.xs-menu {
  position: fixed;
  z-index: 20;
  background-color: #fff;
  color: #333;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
  &.isOpen {
    pointer-events: inherit;
    opacity: 1;
  }
}
.logo-mobile {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 2;
}
#logo-mobile {
  path {
    fill: #333;
  }
  &.white {
    path {
      fill: #fff;
    }
  }
}
.btn-light {
  background-color: #fff;
  border-color: #fff;
}
</style>